import { jsx as e, jsxs as a } from "react/jsx-runtime";
import * as p from "react";
import { useState as f } from "react";
const d = (t) => /* @__PURE__ */ p.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ p.createElement("path", { d: "M12 13.4L7.1 18.3C6.91667 18.4833 6.68334 18.575 6.4 18.575C6.11667 18.575 5.88334 18.4833 5.7 18.3C5.51667 18.1167 5.425 17.8833 5.425 17.6C5.425 17.3167 5.51667 17.0833 5.7 16.9L10.6 12L5.7 7.09999C5.51667 6.91665 5.425 6.68332 5.425 6.39999C5.425 6.11665 5.51667 5.88332 5.7 5.69999C5.88334 5.51665 6.11667 5.42499 6.4 5.42499C6.68334 5.42499 6.91667 5.51665 7.1 5.69999L12 10.6L16.9 5.69999C17.0833 5.51665 17.3167 5.42499 17.6 5.42499C17.8833 5.42499 18.1167 5.51665 18.3 5.69999C18.4833 5.88332 18.575 6.11665 18.575 6.39999C18.575 6.68332 18.4833 6.91665 18.3 7.09999L13.4 12L18.3 16.9C18.4833 17.0833 18.575 17.3167 18.575 17.6C18.575 17.8833 18.4833 18.1167 18.3 18.3C18.1167 18.4833 17.8833 18.575 17.6 18.575C17.3167 18.575 17.0833 18.4833 16.9 18.3L12 13.4Z", fill: "#646060" })), u = ({
  label: t,
  type: i,
  disabled: o = !1,
  inverted: r = !1,
  dense: c = !1,
  onClose: s = () => {
  },
  id: n,
  name: l,
  value: g,
  onChange: m
}) => {
  const C = ["chip", r ? "chip--inverse" : ""].filter(Boolean).join(" "), h = () => i === "dismissible" ? /* @__PURE__ */ a("button", { className: C, onClick: s, disabled: o, children: [
    t,
    /* @__PURE__ */ e(d, {})
  ] }) : /* @__PURE__ */ a("label", { className: C, htmlFor: n, children: [
    t,
    /* @__PURE__ */ e(
      "input",
      {
        type: "checkbox",
        disabled: o,
        checked: g,
        onChange: m,
        ...n && { id: n },
        ...l && { name: l }
      }
    )
  ] });
  return c ? /* @__PURE__ */ e("section", { className: "ui--dense", children: h() }) : h();
};
u.displayName = "Chip";
const b = ({
  text: t,
  className: i,
  id: o,
  children: r,
  chevron: c = !0,
  position: s
}) => {
  const [n, l] = f(!0);
  return /* @__PURE__ */ e("section", { className: "d-flex flex--justify-content-center padding--4 padding-y--12", children: /* @__PURE__ */ e(
    "div",
    {
      "aria-label": t,
      className: `${n ? "tooltip" : ""} tooltip--${s} ${i || ""} ${c ? "" : "no-chevron"}`,
      id: o,
      onMouseEnter: () => l(!0),
      onClick: () => l(!1),
      onMouseLeave: () => l(!1),
      children: r
    }
  ) });
}, v = (t) => /* @__PURE__ */ p.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ p.createElement("path", { d: "M8.7 17.3C8.51667 17.1167 8.425 16.8833 8.425 16.6C8.425 16.3167 8.51667 16.0833 8.7 15.9L12.6 12L8.7 8.09999C8.51667 7.91665 8.425 7.68332 8.425 7.39999C8.425 7.11665 8.51667 6.88332 8.7 6.69999C8.88334 6.51665 9.11667 6.42499 9.4 6.42499C9.68334 6.42499 9.91667 6.51665 10.1 6.69999L14.7 11.3C14.8 11.4 14.871 11.5083 14.913 11.625C14.9543 11.7417 14.975 11.8667 14.975 12C14.975 12.1333 14.9543 12.2583 14.913 12.375C14.871 12.4917 14.8 12.6 14.7 12.7L10.1 17.3C9.91667 17.4833 9.68334 17.575 9.4 17.575C9.11667 17.575 8.88334 17.4833 8.7 17.3Z", fill: "#646060" })), x = ({
  headerText: t,
  bodyText: i,
  position: o = "top",
  chevron: r = !0,
  children: c,
  link: s = "Link",
  linkText: n = "",
  onClose: l = () => {
  },
  isVisible: g = !0
}) => /* @__PURE__ */ e(
  "section",
  {
    className: "d-flex flex--align-items-center flex--justify-content-center padding--4",
    children: /* @__PURE__ */ a("span", { className: "toggle-tip__wrapper", children: [
      /* @__PURE__ */ e("p", { children: c }),
      /* @__PURE__ */ a(
        "div",
        {
          className: `toggle-tip ${g ? "toggle-tip--visible" : ""} toggle-tip--${o} ${r ? "" : "toggle-tip--no-chevron"}`,
          children: [
            /* @__PURE__ */ e("p", { className: "toggle-tip__header", children: t }),
            /* @__PURE__ */ e(
              "button",
              {
                "aria-label": "close toggle-tip",
                className: "toggle-tip__close button button--secondary",
                onClick: l,
                type: "button",
                children: /* @__PURE__ */ e(d, {})
              }
            ),
            /* @__PURE__ */ e("div", { className: "toggle-tip__content", children: i }),
            s && /* @__PURE__ */ a("a", { className: "link toggle-tip__link", href: s, target: "_blank", rel: "noopener noreferrer", children: [
              /* @__PURE__ */ e("span", { children: n || "Link" }),
              /* @__PURE__ */ e(v, {})
            ] })
          ]
        }
      )
    ] })
  }
);
export {
  u as Chip,
  x as ToggleTip,
  b as Tooltip
};
